<template>
  <span v-if="mostrarTela">
    <span v-if="primeiroAcesso">
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="9">
              <h3>Seja bem vindo(a) {{ usuario.nome }}!</h3>
            </b-col>
            <b-col md="3">
              <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
              <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
              <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
              <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <h2>Informações e notícias</h2>
              <carousel :navigationEnabled="true" v-if="informacoes !== undefined" :perPage="3">
                <slide
                  v-for="(informacao, index) in informacoes"
                  :key="informacao.id"
                  class="p-2"
                >
                  <b-card
                    style="max-width: 260px; max-heigth: 260px"
                    @click="modalinformacao(informacao.id)"
                    :img-src="informacao.imagem_capa"
                    img-alt="Image"
                    img-top
                    tag="article"
                  >
                    <b-card-body class="limit-body">
                      <b-card-title>{{ informacao.titulo }}</b-card-title>
                      <b-card-text>
                        {{ verificaTexto(informacao.texto) }}
                      </b-card-text>
                    </b-card-body>
                  </b-card>
                </slide>
              </carousel>
            </b-col>
            <b-col v-if="informacoes !== undefined" cols="11 text-right">
              <a
                @click="navigate('informacoes-noticias')"
                class="action"
                style="color: sandybrown; font-size: 16px"
                ><strong> Ver Todos </strong></a
              >
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12">
              <h2>Programas da minha cidade</h2>
              <carousel :navigationEnabled="true" v-if="programas !== undefined" :perPage="3">
                <slide
                  v-for="programa in programas"
                  :key="programa.id"
                  class="p-2"
                >
                  <b-card
                    style="max-width: 260px; max-heigth: 260px"
                    @click="modalprograma(programa.id)"
                    :img-src="programa.imagem_capa"
                    img-alt="Image"
                    img-top
                    tag="article"
                  >
                  <b-card-body class="limit-body">
                      <b-card-title>{{ programa.nome }}</b-card-title>
                    <b-card-text>
                      {{ verificaTexto(programa.texto) }}
                    </b-card-text>
                  </b-card-body>
                  </b-card>
                </slide>
              </carousel>
            </b-col>
            <b-col v-if="informacoes !== undefined" cols="11 text-right">
              <a
                @click="navigate('programas-municipios-listar')"
                style="color: sandybrown; font-size: 16px"
                class="action"
                ><strong> Ver Todos </strong></a
              >
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer class="p-12"> </b-card-footer>
      </b-card>
      <b-modal
          title="Programa do Município"
          size="md"
          :hide-footer="true"
          v-model="modalprog"
        >
          <b-card
            style="width: 28rem"
            :img-src="prog.imagem_capa"
            img-alt="Card image"
            img-height="300"
            img-width="300"
            img-top
            class="mb-3"
          >
            <a>
              <b-card-text>
                <p>
                  <b>{{ prog.nome }}</b>
                </p>
                <p>{{ prog.texto }}</p>
              </b-card-text>
            </a>
            <div>
              <b-button block variant="primary" @click="abrirLink(prog.link)">
                <span>Link</span>
              </b-button>
            </div>
            <b-card-footer class="p-12">
              <b-button variant="secondary" @click="fecharmodalprog"
                ><i class="fa fa-mail-reply-all"></i> Voltar</b-button
              >
            </b-card-footer>
          </b-card>
        </b-modal>

        <b-modal
          title="Informação e Notícia"
          size="sm"
          :hide-footer="true"
          v-model="modalinfo"
        >
          <b-card
            :img-src="info.imagem_capa"
            img-alt="Card image"
            img-height="300"
            img-width="300"
            img-top
            align="center"
            class="mb-3 text-center"
          >
            <a>
              <b-card-text>
                <p>
                  <b>{{ info.titulo }}</b>
                </p>
                <p>{{ info.texto }}</p>
              </b-card-text>
            </a>
            <b-card-footer class="p-12">
              <b-button variant="secondary" @click="fecharmodalinfo"
                ><i class="fa fa-mail-reply-all"></i> Voltar</b-button
              >
            </b-card-footer>
          </b-card>
        </b-modal>
    </span>
    <span v-else>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="9">
              <h3>Seja bem vindo(a) {{ usuarioLogado.nome }}!</h3>
              <br />
              <p>Você está sendo acompanhada pelo voluntário:(a)</p>
              <p><b>Nome:</b> {{ voluntario.nome }}</p>
              <p><b>Voluntária desde:</b> {{ voluntario.desde }}</p>
            </b-col>
            <b-col md="3">
              <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
              <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
              <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
              <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="6">
              <h3>Atendimentos</h3>
              <p>Seus atendimentos ordenados por data</p>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Encontro</th>
                    <th scope="col">Dia</th>
                    <th scope="col">Realizado</th>
                    <th scope="col">Avaliação</th>
                  </tr>
                </thead>
                <tbody v-if="atendimentos.data !== undefined">
                  <tr v-for="atend in atendimentos.data" :key="atend.id">
                    <td>{{ atend.ordem }}º Encontro</td>
                    <td>
                      {{ atend.data_encontro | formatDateToBR }} -
                      {{ atend.horarios[0].horario }}
                    </td>
                    <td>
                      <span v-if="atend.realizado == 'SIM'">Sim</span>
                      <span v-if="atend.realizado == 'CANCELADO'"
                        >Cancelado</span
                      >
                      <span
                        v-if="
                          atend.realizado == 'NAO' &&
                          atend.situacao == 'PENDENTE'
                        "
                      >
                        -
                      </span>
                      <span
                        v-if="
                          atend.realizado == 'NAO' &&
                          atend.situacao != 'PENDENTE'
                        "
                      >
                        Não
                      </span>
                    </td>
                    <td style="width: 15%">
                      <a
                        v-if="
                          atend.realizado == 'SIM' &&
                          atend.estrelas_beneficiaria === null
                        "
                        class="btn btn-sm btn-secondary action"
                        title="Avaliar Atendimento"
                        @click="avaliarUsuario(atend.id)"
                      >
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a
                        v-if="permiteCancelamento(atend.data_encontro, atend)"
                        class="btn btn-sm btn-secondary action"
                        title="Cancelar com antecedência"
                        @click="cancelarAntecedencia(atend.id)"
                      >
                        <i class="fa fa-power-off"></i>
                      </a>
                      <a
                        v-if="
                          permiteAnexarDocumento(atend.data_encontro, atend) &&
                          atend.realizado == 'CANCELADO' &&
                          atend.situacao == 'PENDENTE'
                        "
                        class="btn btn-sm btn-secondary action"
                        title="Anexar documento da Justificativa do Cancelamento"
                        @click="anexarDocumentoJustificativa(atend.id)"
                      >
                        <i class="fa fa-file-image-o"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="7">Nenhum registro de atendimentos...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="atendimentos.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
              ></pagination>
            </b-col>
            <b-col md="6" v-if="false">
              <h3>Rodas de conversa</h3>
              <p>Escolha uma das datas para participar da roda de conversa</p>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Dia</th>
                    <th scope="col">Tema</th>
                    <th scope="col">Situação de Presença</th>
                    <th scope="col">Participar?</th>
                  </tr>
                </thead>
                <tbody v-if="arrayRodas !== undefined">
                  <tr v-for="roda in arrayRodas" :key="roda.id">
                    <td>{{ formatDate(roda.data) }}</td>
                    <td>{{ verificaTema(roda.tema) }}</td>
                    <td>
                      {{ buscaSituacao(roda.inscricoes) }}
                    </td>
                    <td>
                      <span
                        v-if="
                          moment(roda.data_hora_minutos).format(
                            'YYYY-MM-DD hh:mm'
                          ) >= moment().format('YYYY-MM-DD hh:mm')
                        "
                      >
                        <span
                          v-if="
                            buscaSituacao(roda.inscricoes) !==
                              'Não Compareceu' &&
                            buscaSituacao(roda.inscricoes) !== 'Não Participou'
                          "
                        >
                          <span
                            v-if="
                              roda.inscricoes.filter(
                                (e) => e.usuario_id === usuarioCorrente
                              ).length > 0
                            "
                          >
                            <a
                              class="btn btn-sm btn-secondary action"
                              title="Sair"
                              @click="sair(roda.id)"
                            >
                              <i class="fa fa-toggle-on"></i>
                            </a>
                          </span>
                          <span v-else>
                            <button
                              class="btn btn-sm btn-secondary action"
                              :disabled="roda.vagas == 0"
                              title="Participar"
                              @click="participar(roda.id)"
                            >
                              <i class="fa fa-toggle-off"></i>
                            </button>
                          </span>
                        </span>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="7">Nenhum registro de rodas de conversa...</td>
                  </tr>
                </tbody>
              </table>
              <paginationAlternative
                v-show="arrayRodas !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource2"
              ></paginationAlternative>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-modal
        title="Cancelar com antecedência"
        :hide-footer="true"
        v-model="modalCancelarAntecedencia"
      >
        <b-card-body>
          <b-form>
            <b-col sm="12">
              <b-form-group label="Justificativa:">
                <b-form-select
                  v-model="cancelar.justificativa"
                  :state="cancelar.justificativaState"
                  :options="justificativas"
                  class="mb-3"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="12" v-if="cancelar.mostrarMotivo">
              <b-form-group label="Não poderei comparecer pois...">
                <b-form-select
                  v-model="cancelar.motivo"
                  :state="cancelar.motivoState"
                  :options="motivos"
                  class="mb-3"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="12" v-if="cancelar.mostrarMotivo">
              <label>Anexar Documento:</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas imagens'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Documento é obrigatório"
              >
                <b-form-file
                  browse-text="Selecione"
                  placeholder="Selecione o documento"
                  v-on:change="uploadDocumento"
                ></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3"
                  >Documento é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col sm="12" v-if="cancelar.mostrarMotivoTexto">
              <b-form-group label="Justifique:">
                <b-form-textarea
                  id="textarea"
                  :state="cancelar.motivoTextoState"
                  v-model="cancelar.motivoTexto"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <span v-if="!loadingCancelar">
            <b-button @click="efetivarCancelamento" variant="primary"
              ><i class="fa fa-check">&nbsp;</i> Enviar</b-button
            >
          </span>
          <span v-else>
            <b-button variant="primary" class="btn" disabled>
              <b-spinner small type="grow"></b-spinner>Enviando...
            </b-button>
          </span>
          <b-button @click="limparForm" variant="secondary"
            ><i class="fa fa-times">&nbsp;</i> Cancelar</b-button
          >
        </b-card-footer>
      </b-modal>
      <b-modal
        title="Documento de justificativa"
        :hide-footer="true"
        v-model="modalDocumentoJustificativa"
      >
        <b-card-body>
          <b-form>
            <b-col sm="12">
              <label>Anexar Documento:</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas imagens'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Documento é obrigatório"
              >
                <b-form-file
                  :state="cancelar.documentoAtrState"
                  browse-text="Selecione"
                  placeholder="Selecione o documento"
                  v-on:change="uploadDocumentoAtr"
                ></b-form-file>
                <b-form-invalid-feedback id="input1LiveFeedback3"
                  >Documento é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-button @click="enviarDocumentoAtr" variant="primary"
            ><i class="fa fa-check">&nbsp;</i> Enviar</b-button
          >
          <b-button
            @click="modalDocumentoJustificativa = false"
            variant="secondary"
            ><i class="fa fa-times">&nbsp;</i> Cancelar</b-button
          >
        </b-card-footer>
      </b-modal>
    </span>
  </span>
</template>

<script>
import Vue from 'vue'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/Pagination'
import PaginationAlternative from '@/components/shared/PaginationAlternative'
import miniToastr from 'mini-toastr'
import moment from 'moment'
import { Carousel, Slide } from 'vue-carousel'

miniToastr.init()

Vue.prototype.moment = moment

export default {
  components: {
    Pagination,
    PaginationAlternative,
    Carousel,
    Slide
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'B') {
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getMeuVoluntario', SessionStorage.get('usuario'))
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.$store.dispatch('buscarDias', {
        usuario_id: SessionStorage.get('usuario')
      })
      this.$store.dispatch('buscarJustificativasBeneficiaria')
      this.$store.dispatch('buscarMotivos')
      this.loadInformacoes()
      this.loadProgramas()
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      id: null,
      modalprog: false,
      prog: [],
      info: [],
      modalinfo: false,
      modalCancelarAntecedencia: null,
      modalDocumentoJustificativa: false,
      voluntario: {
        nome: '',
        desde: ''
      },
      informacoes: [],
      programas: [],
      arrayRodas: [],
      slide: 0,
      sliding: null,
      horariotext: '',
      meusAtendimentos: [],
      totalPorPagina: 10,
      resource: 'atendimento',
      resource2: 'roda',
      mostrarTela: false,
      primeiroAcesso: true,
      dia: null,
      turno: null,
      local: null,
      horario: null,
      turnoDisabled: true,
      localDisabled: true,
      horarioDisabled: true,
      blockConfirmacao: true,
      disable_buttons: false,
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      arrVerificaLotacao: [],
      loadingCancelar: false,
      loadingNaoComparecer: false,
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      cancelar: {
        justificativa: null,
        justificativaState: null,
        motivo: null,
        motivoState: null,
        mostrarMotivoTexto: false,
        mostrarMotivo: false,
        motivoTexto: null,
        motivoTextoState: null,
        documento: null,
        documentoAtr: null,
        documentoAtrState: null
      }
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    dias () {
      return this.$store.state.combos.listaDias
    },
    turnos () {
      return this.$store.state.combos.listaTurnos
    },
    locais () {
      return this.$store.state.combos.listaLocais
    },
    horarios () {
      return this.$store.state.combos.listaHorarios
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    meuVoluntario () {
      return this.$store.state.usuario.meuVoluntario
    },
    justificativas () {
      return this.$store.state.atendimento.justificativas
    },
    motivos () {
      return this.$store.state.atendimento.motivos
    },
    motivosRemocao () {
      return this.$store.state.atendimento.motivosRemocao
    },
    atendimentos () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    rodas () {
      if (this.$store.state.paginationAlternative.getList.data !== undefined) {
        if (this.$store.state.paginationAlternative.getList.data.length !== 0) {
          return this.$store.state.paginationAlternative.getList
        } else {
          return false
        }
      }
      return this.$store.state.paginationAlternative.getList
    }
  },
  watch: {
    rodas: function () {
      var array = []
      // var data_hora_mais_minutos = null
      // var data_hora_minutos = null
      $.each(this.rodas.data, function (key, value) {
        Vue.http.get('api/roda/buscar-vagas/' + value.id).then((response) => {
          if (response.data.success) {
            if (value.horario_inicio) {
              var hora_roda =
                value.horario_inicio.replace(/([^\d])+/gim, '') + ':01'
              var data_roda = value.data + ' ' + hora_roda
            }

            if (response.data.data.vagas_disponiveis_beneficiario == 0) {
              array.push({
                vagas: 0,
                data: value.data,
                id: value.id,
                tema: value.tema,
                inscricoes: value.inscricoes,
                usuario_id: value.usuario_id
              })
            } else {
              array.push({
                vagas: response.data.data.vagas_disponiveis_beneficiario,
                data: value.data,
                id: value.id,
                tema: value.tema,
                inscricoes: value.inscricoes,
                usuario_id: value.usuario_id,
                data_hora_minutos: data_roda
              })
            }
          }
        })
      })
      this.arrayRodas = array
    },
    atendimentos: function () {
      if (this.atendimentos.data.length) {
        this.horariotext = this.atendimentos.data[0].horarios[0].horario
      }
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    municipiosprogramas: function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.perfil': function () {
      if (this.usuarioLogado.nome === '') {
        this.usuarioLogado.nome = this.usuario.nome
        this.usuarioLogado.perfil = this.usuario.perfil.nome
      }
    },
    'usuario.atendimentos': function () {
      if (!this.usuario.disponivel) {
        this.primeiroAcesso = false
      }
      this.mostrarTela = true
    },
    dia: function () {
      if (this.dia !== null) {
        this.$store.dispatch('buscarTurnos', {
          usuario_id: SessionStorage.get('usuario'),
          dia: this.dia
        })
        this.turnoDisabled = false
      } else {
        this.turnoDisabled = true
        this.turno = null
      }
    },
    turno: function () {
      if (this.turno !== null) {
        this.$store.dispatch('buscarLocaisCombo', {
          usuario_id: SessionStorage.get('usuario'),
          dia: this.dia,
          periodo: this.turno
        })
        this.localDisabled = false
      } else {
        this.localDisabled = true
        this.turno = null
        this.local = null
      }
    },
    local: function () {
      if (this.local !== null) {
        this.horarioDisabled = false
        this.$store.dispatch('buscarHorarios', {
          usuario_id: SessionStorage.get('usuario'),
          dia: this.dia,
          periodo: this.turno,
          local_id: this.local
        })
      } else {
        this.horarioDisabled = true
        this.horario = null
      }
    },
    horario: function () {
      if (this.local !== null) {
        this.blockConfirmacao = false
      }
    },
    meuVoluntario: function () {
      if (this.meuVoluntario) {
        this.voluntario.nome = this.meuVoluntario.nome
        this.voluntario.desde = this.formatDate(this.meuVoluntario.created_at)
      }
    },
    'cancelar.justificativa': function () {
      if (this.cancelar.justificativa !== null) {
        this.cancelar.motivo = null
        this.cancelar.motivoState = null
        this.cancelar.motivoTexto = null
        this.cancelar.motivoTextoState = null

        if (this.cancelar.justificativa === 'CJ') {
          this.cancelar.mostrarMotivo = true
        }
        if (this.cancelar.justificativa === 'SJ') {
          this.cancelar.mostrarMotivo = false
          this.cancelar.mostrarMotivoTexto = false
        }
      }
    },
    'cancelar.motivo': function () {
      this.cancelar.motivoTexto = null
      this.cancelar.motivoTextoState = null

      if (this.cancelar.motivo !== null) {
        if (parseInt(this.cancelar.motivo) === 4) {
          this.cancelar.mostrarMotivoTexto = true
        } else {
          this.cancelar.mostrarMotivoTexto = false
        }
      }
    }
  },
  methods: {
    permiteAnexarDocumento: function (data, atendimento) {
      if (atendimento.imagem_anexada) {
        return false
      } else {
        if (this.verificarDiferencaDias(data) <= 3) {
          return true
        } else {
          return false
        }
      }
    },
    verificaTema (tema) {
      switch (parseInt(tema)) {
        case 1:
          return 'Tema 1'
        case 2:
          return 'Tema 2'
        case 3:
          return 'Tema 3'
        case 4:
          return 'Tema 4'
        case 5:
          return 'Tema 5'
        case 6:
          return 'Tema 6'
        case 7:
          return 'Tema 7'
        case 8:
          return 'Tema 8'
        case 9:
          return 'Tema 9'
        case 10:
          return 'Tema 10'
        case 11:
          return 'Tema 11'
        case 12:
          return 'Tema 12'
        default:
          return 'Tema 1'
      }
    },
    verificarDiferencaDias (dt1) {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const firstDate = new Date(dt1)
      const secondDate = new Date()

      return Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    formatDate (criadoEm) {
      let date = new Date(criadoEm)

      let day = date.getDate()
      let month = date.getMonth() + 1

      if (month < 10) {
        month = '0' + month
      }

      if (day < 9) {
        day = '0' + (day + 1)
      } else {
        day = day + 1
      }

      return day + '/' + month + '/' + date.getFullYear()
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    },
    cancelarAntecedencia: function (id) {
      this.modalCancelarAntecedencia = true
      this.id = id
    },
    avaliarUsuario: function (id) {
      this.$router.push('/atendimento/' + id + '/avaliacao')
    },
    efetivarCancelamento () {
      if (this.validarFormCancelamento()) {
        let data = {
          atendimento_id: this.id,
          justificativa: this.cancelar.justificativa,
          imagem: this.cancelar.documento
        }

        if (
          this.cancelar.justificativa === 'CJ' ||
          this.cancelar.justificativa === 'CJ'
        ) {
          data.motivo = this.cancelar.motivo

          if (parseInt(this.cancelar.motivo) === 4) {
            data.justificativa_texto = this.cancelar.motivoTexto
          }
        }

        this.loadingCancelar = true

        Vue.http
          .post('api/voluntario/cancelarAtendimento', data)
          .then((response) => {
            this.limparForm()
            this.loadingCancelar = false
            this.$store.dispatch('getRegistros', {
              resource: this.resource,
              limit: this.totalPorPagina
            })
          })
          .catch((e) => {
            let response = e.body
            this.loadingCancelar = false
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.msg, 'Ops!', 9000)
          })
      }
    },
    limparForm () {
      this.modalCancelarAntecedencia = false
      this.cancelar.justificativa = null
      this.cancelar.justificativaState = null
      this.cancelar.motivo = null
      this.cancelar.motivoState = null
      this.cancelar.mostrarMotivoTexto = false
      this.cancelar.mostrarMotivo = false
      this.cancelar.motivoTexto = null
      this.cancelar.motivoTextoState = null
      this.cancelar.documento = null
    },
    permiteCancelamento: function (data, atendimento) {
      let specificDate = new Date(data)
      let currentDate = new Date()

      if (currentDate.getTime() > specificDate.getTime()) {
        return false
      } else {
        if (atendimento.realizado !== 'CANCELADO') {
          if (this.verificarDiferencaDias(data) > 1) {
            return true
          }
        }
        return false
      }
    },
    buscaSituacao (inscricoes) {
      let inscricao = inscricoes.filter(
        (e) => e.usuario_id === this.usuarioCorrente
      )
      if (inscricao[0]) {
        inscricao[0].status
        return this.descricaoStatus(inscricao[0].status)
      } else {
        return 'Pendente'
      }
    },
    buscarVagas (idRoda) {
      Vue.http.get('api/roda/buscar-vagas/' + idRoda).then((response) => {
        if (response.data.success) {
          return response.data.data.vagas_disponiveis_beneficiario
        }
      })
    },
    descricaoStatus: function (status) {
      let descricao = ''

      switch (status) {
        case null:
          descricao = 'Pendente'
          break
        case 0:
          descricao = 'Pendente'
          break
        case 1:
          descricao = 'Vaga Reservada'
          break
        case 2:
          descricao = 'Confirmada'
          break
        case 3:
          descricao = 'Desistente'
          break
        case 4:
          descricao = 'Não Compareceu'
          break
        case 5:
          descricao = 'Não Participou'
          break
      }
      return descricao
    },
    onSubmit () {
      this.$bvModal
        .msgBoxConfirm(
          'Confirma a ação? Os horários de atendimento serão criados sempre para o horário selecionado durante a vigência do programa que será da informação contida na inscrição até 2 anos de vida da criança. Ocorrerá sempre de 4 em 4 semanas.',
          {
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }
        )
        .then((valor) => {
          if (valor) {
            let horario = null
            if (this.horario != null) {
              horario = this.horario.toUpperCase()
              horario = horario.slice(0, -1)
            }
            Vue.http
              .post('api/atendimento', {
                usuario_id: SessionStorage.get('usuario'),
                dia: this.dia,
                periodo: this.turno,
                local_id: this.local,
                horario: horario
              })
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch(
                    'getUsuario',
                    SessionStorage.get('usuario')
                  )
                  this.$store.dispatch(
                    'getMeuVoluntario',
                    SessionStorage.get('usuario')
                  )
                }
              })
              .catch((erro) => {
                miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
                miniToastr.error(erro.body.msg, 'Ops!', 9000)
              })
          }
        })
        .catch((erro) => {
          let response = erro.body

          if (response.data) {
            let erros = Object.values(response.data)

            for (let erro of erros) {
              miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
              miniToastr.error(erro, 'Ops!', 9000)
            }
          }
        })
    },
    uploadDocumento (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.cancelar.documento = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDocumentoAtr (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.cancelar.documentoAtr = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    anexarDocumentoJustificativa (id) {
      this.modalDocumentoJustificativa = true
      this.id = id
    },
    validarFormCancelamento () {
      let valid = true

      if (!this.cancelar.justificativa) {
        valid = false
        this.cancelar.justificativaState = false
      } else {
        this.cancelar.justificativaState = true
      }

      if (
        this.cancelar.justificativa === 'CJ' ||
        this.cancelar.justificativa === 'CJ'
      ) {
        if (!this.cancelar.motivo) {
          valid = false
          this.cancelar.motivoState = false
        } else {
          this.cancelar.motivoState = true

          if (parseInt(this.cancelar.motivo) === 4) {
            if (!this.cancelar.motivoTexto) {
              valid = false
              this.cancelar.motivoTextoState = false
            } else {
              this.cancelar.motivoTextoState = true
            }
          }
        }
      }

      return valid
    },
    enviarDocumentoAtr () {
      if (!this.cancelar.documentoAtr) {
        this.cancelar.documentoAtrState = false
        return false
      }

      let data = {
        atendimento_id: this.id,
        imagem_anexada: this.cancelar.documentoAtr,
        tipo: 'BENEFICIARIA'
      }

      Vue.http
        .post('api/voluntario/informarDocumento', data)
        .then((response) => {
          this.modalDocumentoJustificativa = false
          this.cancelar.documentoAtrState = null
          miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
          miniToastr.success('Imagem anexada com sucesso!', 'Sucesso!', 7000)
          this.$store.dispatch('getRegistros', {
            resource: this.resource,
            limit: this.totalPorPagina
          })
        })
    },
    sair (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma a saída da roda de conversa?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get(
                'api/roda/excluir-participante/' +
                  SessionStorage.get('usuario') +
                  '/' +
                  id
              )
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearchAlternative', {
                    resource: this.resource2,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearchAlternative', {
              resource: this.resource2,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    participar (id) {
      let data = {
        usuario_id: parseInt(SessionStorage.get('usuario')),
        id: id
      }
      this.$bvModal
        .msgBoxConfirm('Confirma a participação da roda de conversa?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http.post('api/roda/participar', data).then((response) => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearchAlternative', {
                  resource: this.resource2,
                  limit: this.totalPorPagina,
                  filtros: this.filtros
                })
              }
            })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearchAlternative', {
              resource: this.resource2,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    loadInformacoes () {
      Vue.http.get('api/informacao/usuario').then((response) => {
        if (response.body.success) {
          this.informacoes = response.body.data
        }
      })
    },
    loadProgramas () {
      Vue.http
        .get('api/programaDeMunicipio/usuario?vigente=true')
        .then((response) => {
          if (response.body.success) {
            this.programas = response.body.data[0]
          }
        })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    abrirLink (link) {
      window.open(link, '_blank')
    },
    modalprograma (id) {
      this.modalprog = true
      Vue.http.get('api/programaDeMunicipios/' + id).then((response) => {
        if (response.body.success) {
          this.prog = response.body.data
        }
      })
    },
    fecharmodalprog (id) {
      this.modalprog = false
      this.prog = []
    },
    modalinformacao (id) {
      this.modalinfo = true
      Vue.http.get('api/informacoes/' + id).then((response) => {
        if (response.body.success) {
          this.info = response.body.data
        }
      })
    },
    fecharmodalinfo (id) {
      this.modalinfo = false
      this.info = []
    },
    verificaTexto (texto) {
      if (texto.length >= 100) {
        return texto.substring(0, 100).concat('...')
      } else {
        return texto
      }
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
.row {
  margin-top: 20px;
}
img {
  width: 260px;
  height: 220px;
}

.card article  {
  cursor: pointer;
}

div .limit-body {
 height: 170px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/PrincipalBeneficiaria.vue